import React, {useState} from 'react';
import {Box, Typography, useTheme} from '@mui/material';
import {CheckCircle, Dot, WrongCircle} from '@jobseeker/lotus/icons';
import {Image} from '@jobseeker/lotus/components/Image';
const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

const passwordMatchContent = [
  {
    title: 'One lowercase character',
    status: '',
    type: 'lower',
  },
  {
    title: 'One uppercase character',
    status: '',
    type: 'upper',
  },
  {
    title: 'One number',
    status: '',
    type: 'number',
  },
  {
    title: 'One special character',
    status: '',
    type: 'special',
  },
  {
    title: '8 character minimum',
    status: '',
    type: 'limit',
  },
  ...(!isAppIimjobs
    ? [
        {
          title: 'Maximum of 20 characters',
          status: '',
          type: 'maxLength',
        },
      ]
    : []),
];

export const useValidateComponent = (
  authlistener?: boolean
): [(password: string) => void, React.FC] => {
  const [passwordContent, setPasswordContent] = useState(passwordMatchContent);

  const handlePasswordRegexValidation = (password: string) => {
    const REGEX_MAP: {[key: string]: RegExp} = {
      lower: /[a-z]/,
      upper: /[A-Z]/,
      number: /\d/,
      special: /[^a-zA-Z0-9\s]/,
      limit: /.{8,}/,
      ...(!isAppIimjobs && {maxLength: /^.{0,20}$/}),
    };

    passwordContent.forEach(content => {
      const valid = REGEX_MAP[content.type].test(password);
      content['status'] = valid ? CheckCircle : WrongCircle;
    });
  };

  const theme = useTheme();
  const Component: React.FC = () => (
    <Box p={!isAppIimjobs && authlistener ? '15px 20px' : '0px'}>
      <Typography
        variant="caption"
        fontWeight={theme.typography.fontWeightBold}
        fontSize={!isAppIimjobs && authlistener ? '14px' : '10px'}
      >
        Your password must include:
      </Typography>
      <Box
        sx={{
          paddingLeft: !isAppIimjobs && authlistener ? 0 : 1,
          mt: 0.5,
        }}
      >
        {passwordContent.map(content => (
          <Box
            key={`${content.type}_index`}
            display={'flex'}
            alignItems={'center'}
            sx={{
              paddingLeft: 0,
              paddingTop: 1,
            }}
          >
            <Image
              src={content.status || Dot}
              alt={'check'}
              width={
                content.status ? 10 : !isAppIimjobs && authlistener ? 10 : 8
              }
              height={
                content.status ? 10 : !isAppIimjobs && authlistener ? 10 : 8
              }
            />
            <Typography
              variant="caption"
              ml={!isAppIimjobs && authlistener ? 1.25 : 0.5}
              fontSize={!isAppIimjobs && authlistener ? '14px' : '10px'}
            >
              {content.title}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );

  return [handlePasswordRegexValidation, Component];
};
